import template from './cycle_setup_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class PerformanceCyclesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class PerformanceCyclesHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new PerformanceCyclesHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'PerformanceCyclesHelp',
	dialog_class: PerformanceCyclesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/cycle_setup_help',
	provider: 'ps'
};